import FilterPill from './FilterPill';
import {useSelector, useDispatch} from 'react-redux';
import React from 'react';
import {clearAll, selectActiveFiltersCount} from './../store/filters';
import {setActiveFilterCategory} from './../store/app';

const FilterList = (props) => {
    let dispatch = useDispatch();
    let filters = useSelector(state => state.filters.filters);
    let activeFilterCount = useSelector(selectActiveFiltersCount);
    let [activeFilters, setActiveFilters] = React.useState([]);

    React.useEffect(() => {
        let af = [];
        for (let filter in filters) {
            filters[filter].options.forEach((option, index) => {
                if (option.active) af.push(<FilterPill key={`${index}${option.name}${filters[filter].dataPoint}`} category={filters[filter]} optionName={option.name} />);
            })
        }
        setActiveFilters(af);
    }, [filters])

    function handleClearAll(e) {
        e.preventDefault();
        dispatch(setActiveFilterCategory(null));
        dispatch(clearAll());
    }
    
    return (
        <div className={`filterCategory minFilter ${!activeFilterCount ? "empty" : ""}`}>
            {activeFilterCount > 0 ? (<button className={"pill"} onClick={handleClearAll}><div className={"crossSymbol"} />CLEAR ALL</button>) : ""}
            {activeFilters}
        </div>
    )
}

export default FilterList;